import { gameName } from '../../enums';
import { soundService } from '../../services';
import { parseQuery } from '../../helpers/parseQuery';
import { userInfoStore } from '../../store/userInfoStore';
import { isMobile } from '../../helpers/isMobile';
import { userSettingsStore } from '../../store/userSettingsStore';
import { resizeGameHandler } from '../../helpers';
import { specificLocalStorageKeys } from '../../constants';

export const init = () => {
  const query = parseQuery(window.location.search);
  const { playerexternalid, currency } = query;
  resizeGameHandler();
  window.addEventListener('resize', resizeGameHandler);

  userInfoStore.setCurrencyCode(currency);
  userInfoStore.setUserId(playerexternalid);

  document.documentElement.classList.add(`is-${isMobile() ? 'mobile' : 'web'}`);

  userSettingsStore.localStorageAndUserSettingsInit({
    gameName,
    soundService,
    gameSpecificData: { [specificLocalStorageKeys.isHideIntro]: false },
  });
};
